module.exports = __webpack_public_path__ + "img/gmail.886e15f5.svg";